import { SagaIterator } from '@redux-saga/core';
import { Auth } from 'aws-amplify';
import { all, takeLatest, put, call, race, take } from 'redux-saga/effects';
import { localRedirect } from 'utils';

import * as Actions from './slice';
import * as Endpoints from './endpoints';

export function* getUserDetails(): SagaIterator {
  try {
    const response = yield call(Endpoints.getUserData);
    yield put(Actions.fetchUserSuccess(response));

    if (response?.account?._links?.['profile:complete']) {
      yield call(statusMessageSaga, {
        type: 'info',
        message: 'Please complete your profile details to get started.'
      });
      yield call(localRedirect, '/settings/my-profile');
    }
  } catch (error: any) {
    yield call(statusMessageSaga, { type: 'error', message: error?.message || error?.detail });
    yield put(Actions.fetchUserFailure(error));
  }
}
export function* statusMessageSaga(data: { type: 'success' | 'error' | 'info' | 'warning'; message: string }) {
  try {
    yield put(Actions.showStatusMessage(data));
    yield race({
      yes: take(Actions.closeStatusMessage)
    });
  } catch (e) {
    yield put(Actions.closeStatusMessage);
  }
}

export function* logout() {
  try {
    yield call([Auth, Auth.signOut], { global: true });
    localRedirect('/login');
    yield put(Actions.logoutSuccess());
  } catch (e) {
    yield call([Auth, Auth.signOut]);
    localRedirect('/login');
  }
}

export function* appManagementWatcherSaga(): SagaIterator {
  yield all([yield takeLatest(Actions.fetchUser.type, getUserDetails), yield takeLatest(Actions.logout.type, logout)]);
}

export default appManagementWatcherSaga;
